/* Imports */
import React from "react"
import { Accordion } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"

const AccordionPage = () => {
    const accordionItems = [
        {
            title: "Item",
            content:
                "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Neque id culpa nam, facere necessitatibus, doloremque provident eveniet suscipit magni, recusandae consequuntur totam eaque error sunt quasi! Dolor culpa consectetur aliquam.",
            isOpen: true,
        },
        {
            title: "Item",
            content:
                "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Neque id culpa nam, facere necessitatibus, doloremque provident eveniet suscipit magni, recusandae consequuntur totam eaque error sunt quasi! Dolor culpa consectetur aliquam.",
        },
        {
            title: "Item",
            content:
                "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Neque id culpa nam, facere necessitatibus, doloremque provident eveniet suscipit magni, recusandae consequuntur totam eaque error sunt quasi! Dolor culpa consectetur aliquam.",
        },
    ]

    const items = [
        {
            title: "Basic",
            content: <Accordion items={accordionItems} accordionStyle="basic" icon="plus" />,
            code: 'const accordionItems = [\n    {\n        title: "Item",\n        content:\n            "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Neque id culpa nam, facere necessitatibus, doloremque provident eveniet suscipit magni, recusandae consequuntur totam eaque error sunt quasi! Dolor culpa consectetur aliquam.",\n        isOpen: true,\n    },\n]\n\n<Accordion items={accordionItems} accordionStyle="basic" icon="plus" />',
        },
        {
            title: "Rounded",
            content: <Accordion items={accordionItems} accordionStyle="rounded" icon="chevron" />,
            code: 'const accordionItems = [\n    {\n        title: "Item",\n        content:\n            "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Neque id culpa nam, facere necessitatibus, doloremque provident eveniet suscipit magni, recusandae consequuntur totam eaque error sunt quasi! Dolor culpa consectetur aliquam.",\n        isOpen: true,\n    },\n]\n\n<Accordion items={accordionItems} accordionStyle="rounded" icon="chevron" />',
        },
    ]

    const propsItems = [
        {
            name: "items",
            type: "Array of objects",
            required: "Yes",
        },
        {
            name: "title (item Object)",
            type: "String",
            example: "Title",
            required: "Yes",
        },
        {
            name: "content (item Object)",
            type: "String or JSX Element",
            example: "Content",
            required: "Yes",
        },
        {
            name: "isOpen (item Object)",
            type: "Boolean",
        },
        {
            name: "accordionStyle",
            type: "String",
            example: "rounded",
            possible: '"basic" | "rounded"',
            default: "basic",
        },
        {
            name: "icon",
            type: "String",
            example: "chevron",
            possible: '"plus" | "chevron"',
            default: "plus",
        },
    ]

    return <ComponentPage items={items} propsItems={propsItems} />
}

export default AccordionPage
